import { render, staticRenderFns } from "./ComplianceDashboard.vue?vue&type=template&id=19738330&scoped=true"
import script from "./ComplianceDashboard.vue?vue&type=script&lang=js"
export * from "./ComplianceDashboard.vue?vue&type=script&lang=js"
import style0 from "./ComplianceDashboard.vue?vue&type=style&index=0&id=19738330&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19738330",
  null
  
)

export default component.exports